module.exports = __webpack_public_path__ + "img/DISPTCHD.1f111c07.svg";